export default class CityProject {
  // 获取中标项目
  static getWindList (sender, data, axiosOption, httpOption) {
    return sender.doUrl('/admin/online/onlineOperation/listByDatasourceId/oaFormWinBidding', 'post', data, axiosOption, httpOption);
  }

  static getList (sender, data, axiosOption, httpOption) {
    return sender.doUrl('/admin/online/onlineOperation/listByDatasourceId/oaFormCityProjecttest', 'post', data, axiosOption, httpOption);
  }
  
  static createdCityProject (sender, data, axiosOption, httpOption) {
    return sender.doUrl('/admin/online/onlineOperation/addDatasource/oaFormCityProjecttest', 'post', data, axiosOption, httpOption);
  }

  static updateCityProject (sender, data, axiosOption, httpOption) {
    return sender.doUrl('/admin/online/onlineOperation/updateDatasource/oaFormCityProjecttest', 'post', data, axiosOption, httpOption);
  }
  
  static deleteCityProject (sender, data, axiosOption, httpOption) {
    return sender.doUrl('/admin/online/onlineOperation/deleteDatasource/oaFormCityProjecttest', 'post', data, axiosOption, httpOption);
  }
}
